function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { TRACE_FLAG_NONE } from '../utils/spanUtils.js';
import { generateTraceId, generateSpanId } from '../utils-hoist/propagationContext.js';

/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */
var SentryNonRecordingSpan = /*#__PURE__*/function () {
  function SentryNonRecordingSpan() {
    var spanContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, SentryNonRecordingSpan);
    this._traceId = spanContext.traceId || generateTraceId();
    this._spanId = spanContext.spanId || generateSpanId();
  }

  /** @inheritdoc */
  return _createClass(SentryNonRecordingSpan, [{
    key: "spanContext",
    value: function spanContext() {
      return {
        spanId: this._spanId,
        traceId: this._traceId,
        traceFlags: TRACE_FLAG_NONE
      };
    }

    /** @inheritdoc */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  }, {
    key: "end",
    value: function end(_timestamp) {}

    /** @inheritdoc */
  }, {
    key: "setAttribute",
    value: function setAttribute(_key, _value) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setAttributes",
    value: function setAttributes(_values) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setStatus",
    value: function setStatus(_status) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "updateName",
    value: function updateName(_name) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "isRecording",
    value: function isRecording() {
      return false;
    }

    /** @inheritdoc */
  }, {
    key: "addEvent",
    value: function addEvent(_name, _attributesOrStartTime, _startTime) {
      return this;
    }

    /** @inheritDoc */
  }, {
    key: "addLink",
    value: function addLink(_link) {
      return this;
    }

    /** @inheritDoc */
  }, {
    key: "addLinks",
    value: function addLinks(_links) {
      return this;
    }

    /**
     * This should generally not be used,
     * but we need it for being compliant with the OTEL Span interface.
     *
     * @hidden
     * @internal
     */
  }, {
    key: "recordException",
    value: function recordException(_exception, _time) {
      // noop
    }
  }]);
}();
export { SentryNonRecordingSpan };